import { useContext } from 'react';

import { SummarianContext } from 'contexts/summarian/SummarianContext';

export const useSummarianContext = () => {
  const summarianState = useContext(SummarianContext);
  return summarianState;
};
